import { Stack, VStack } from "@chakra-ui/react";
import React from "react";
import AnnouncementsLeft from "./components/AnnouncementsLeft";
import AnnouncementsRight from "./components/AnnouncementsRight";

const Announcements = () => {
  return (
    <VStack w="100%">
      <VStack flexDir="row" alignItems="center" w="100%">
        <Stack w="70%" bg="rgba(245, 245, 255, 1)" pt="80px">
          <AnnouncementsLeft />
        </Stack>
        <Stack
          w="30%"
          bg="rgba(255, 255, 255, 1)"
          pt="80px"
          justifyContent="center"
          h="100%"
        >
          <AnnouncementsRight />
        </Stack>
      </VStack>
    </VStack>
  );
};

export default Announcements;
